import { ToggleButton } from "../StoryPreview";
import { Stack, Typography } from "@mui/material";
import { Confirm, IconButton, Flex, Snackbar } from "ui";
import { MoreItem } from "./MoreButton";
import PropTypes from "prop-types";

function ShareButton({ mode, onClose, story }) {
  return (
    <ShareOptions onClose={onClose} story={story}>
      {mode === "menu" ? (
        <MoreItem icon="share">Compartir</MoreItem>
      ) : (
        <ToggleButton icon="share" label="Compartir" />
      )}
    </ShareOptions>
  );
}

const MediaIcon = ({ label, icon, svg, onClick, url }) => {
  return (
    <Stack spacing={1} alignItems="center">
      <IconButton
        onClick={() => {
          if (onClick) onClick();
          else if (url) window.open(url, "_blank");
        }}
        icon={icon}
        svg={svg}
      />
      <small>{label}</small>
    </Stack>
  );
};

ShareButton.propTypes = {
  onClose: PropTypes.func.isRequired,
  story: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isOwner: PropTypes.bool,
    isPublic: PropTypes.bool,
  }).isRequired,
};

export const ShareOptions = ({ children, onClose, story }) => {
  const msg = `¡Hola! Te comparto el libro "${story.name}" de Monus. Puedes verlo en: `;
  const url = `${process.env.MONUS_APP_URL}/library/${story._id}/`;

  return (
    <Confirm
      title="Comparte este libro"
      description={
        <Stack spacing={2}>
          <Typography>
            Puedes compartir este libro con tus amigos y familiares en las redes
            sociales.
          </Typography>
          <Flex spacing={1.5}>
            <MediaIcon
              label="Facebook"
              svg="facebook"
              url={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
            />
            <MediaIcon
              label="WhatsApp"
              svg="whatsapp"
              url={`https://wa.me/?text=${msg}${url}`}
            />
            <MediaIcon
              label="Telegram"
              svg="telegram"
              url={`https://t.me/share/url?url=${url}&text=${msg}`}
            />
            <MediaIcon
              label="X"
              svg="twitter"
              url={`https://x.com/intent/post?text=${msg}${url}`}
            />
            <Snackbar message="Enlace copiado al portapapeles">
              <MediaIcon
                label="Copiar enlace"
                icon="content_copy"
                onClick={() => {
                  navigator.clipboard.writeText(url);
                  if (typeof onClose === "function") onClose();
                }}
              />
            </Snackbar>
          </Flex>
        </Stack>
      }
    >
      {children}
    </Confirm>
  );
};

ShareOptions.propTypes = {
  children: PropTypes.node.isRequired,
  mode: PropTypes.string,
  onClose: PropTypes.func,
  story: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default ShareButton;
